/**
 *   Generated file. Do not edit
 */

export const ResourceMetaData = {
  '/time/ntp-server': {
    put: {
      minApiVersion: 1.107,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 100,
      },
    },
  },

  '/time/time-zone': {
    put: {
      minApiVersion: 1.107,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 64,
      },
    },
  },
};
